import { useQueryWithUserId } from '@northladder/services';

import { USER_ACCOUNTS_API } from '../userAccountsAPIClient';

/**
 * React query state key for fetch notification unread api it can invalidate
 * the state of bid stepper value
 */
export const FETCH_NOTIFICATION_UN_UNREAD_STATUS =
  'fetch-notification-un-read-status-query-key';

/**
 * React Query hook for Notification Unread status it will call
 * `fetchUnReadNotification` and give error loading success state with response
 */
export const useUnreadNotificationQuery = () => {
  const { data, isError, error, isLoading, refetch, isSuccess } =
    useQueryWithUserId({
      queryKey: [FETCH_NOTIFICATION_UN_UNREAD_STATUS],
      queryFn: () => USER_ACCOUNTS_API.fetchUnreadNotification(),
      retry: false,
    });

  return {
    data,
    isError,
    error,
    isLoading,
    isSuccess,
    refetch,
  };
};
